import { LogoSVG } from 'components/styled';
import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

type Breakpoints = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export function HeaderSVG({ name, useSizeBP }: { name: string; useSizeBP?: boolean }) {
  return <LogoSVG name={name} set="assets" width="253" height="40" useSizeBP={useSizeBP} />;
}

export function InterMountainSVG({
  breakpoint = 'sm',
  useSizeBP = true
}: {
  breakpoint?: Breakpoints;
  useSizeBP?: boolean;
}) {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up(breakpoint));
  return (
    <HeaderSVG
      useSizeBP={useSizeBP}
      name={isLargeScreen ? 'Intermountain' : 'IntermountainGreyed'}
    />
  );
}

export function SelectHealthSVG({
  breakpoint = 'sm',
  useSizeBP = true
}: {
  breakpoint?: Breakpoints;
  useSizeBP?: boolean;
}) {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up(breakpoint));
  return (
    <HeaderSVG
      useSizeBP={useSizeBP}
      name={isLargeScreen ? 'SelectHealthNew' : 'SelectHealthGreyed'}
    />
  );
}
